import { REHYDRATE } from "redux-persist/constants";
import { UPDATE_APP_CONFIG, RESET_APP_CONFIG } from "./AdminPanel.action.react";
import { appConfig } from "config/initializers/config.app";
const initialAppConfigState = appConfig;

const AppConfigReducer = (state = initialAppConfigState, action) => {
    switch (action.type) {
        case REHYDRATE:
            let appConfig = action.payload.appConfig;
            if (appConfig) {
                return appConfig;
            } else {
                return state;
            }
        case UPDATE_APP_CONFIG:
            return action.data;
        case RESET_APP_CONFIG:
            return initialAppConfigState;
        default:
            return state;
    }
};

export { AppConfigReducer };
